import {
  FETCH_EMPLOYEE_LIST_WITH_IMAGES,
} from './constants'

const fetchEmployeeListWithImages = (username) => ({ type: FETCH_EMPLOYEE_LIST_WITH_IMAGES, username })

export {
  fetchEmployeeListWithImages
}
